import { ManualJCalculationResult } from './manualJAgent.models';

export interface ManualJAgentState {
  results: ManualJCalculationResult[];
  currentResult: ManualJCalculationResult | null;
  error: string | null;
  isLoading: boolean;
}

type Action =
  | { type: 'CALCULATE_LOAD_START' }
  | {
      type: 'CALCULATE_LOAD_SUCCESS';
      payload: { result: ManualJCalculationResult };
    }
  | { type: 'CALCULATE_LOAD_FAILURE'; payload: { error: string } }
  | { type: 'CALCULATE_LOAD_CANCELLED' }
  | { type: 'CLEAR_CURRENT_RESULT' }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean };
    };

export const initState: ManualJAgentState = {
  results: [],
  currentResult: null,
  error: null,
  isLoading: false,
};

export const manualJAgentReducer = (
  state: ManualJAgentState,
  action: Action
): ManualJAgentState => {
  switch (action.type) {
    case 'CALCULATE_LOAD_START':
      return {
        ...state,
        error: null,
        isLoading: true,
      };

    case 'CALCULATE_LOAD_SUCCESS':
      return {
        ...state,
        isLoading: false,
        currentResult: action.payload.result,
        results: [action.payload.result, ...state.results],
      };

    case 'CALCULATE_LOAD_CANCELLED':
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case 'CALCULATE_LOAD_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case 'CLEAR_CURRENT_RESULT':
      return {
        ...state,
        currentResult: null,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
